import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { BsModalService } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';

import { CashInService, CommonService, ClientWalkInService, SubscribeService, BranchService } from '../../../services/index';
import { CashInModal } from '../../../model/index';

import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';

@Component({
    selector: 'add-cash-in-tab',
    templateUrl: './addCashIn.component.html'
})
export class AddCashInComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    //@Input() params;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        if (!val['hv_username'] && !val['acc_user']) {
            val['out_type'] = 'Branch';
        }
        this._params = val;
        this.setPageData();
    }
    public mode: string;
    //@Output() transferChellOutUpdateEvent = new EventEmitter();

    @Input() cashInData: CashInModal[] = [];
    @Input() cashInRow: CashInModal[] = [];
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('branchAutoComp') branchAutoComp;

    isLoading: boolean = false;
    minDate: any;

    constructor(
        public store: Store<fromRootStore.State>,
        private modalService: BsModalService,
        public toasterService: ToasterService,
        private commonService: CommonService,
        private BranchService: BranchService,
        private cashInService: CashInService,
        private clientWalkInService: ClientWalkInService, public subscribeService: SubscribeService
    ) {}

    reorderable: boolean = true;

    page = {
        limit: 50,
        count: 0,
        offset: 0,
        orderBy: 'model_id',
        orderDir: 'asc'
    };

    cashInList = [];

    ngOnInit(): void {

        let that = this;
        if (this._params['mode'] == 'Add') {
            this.minDate = new Date(new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate());
            this.cashInData['date'] = new Date();

            this.getAutoNumber();
        }
    }
    
    getAutoNumber() {
        let that = this,
            cashInDate = moment(this.cashInData['date']).format('YYYY-MM-DD'),
            params = {
                account_type: 'cashIn',
                date: cashInDate,
            };
        this.commonService.getAutoNumber(params)
            .then(function (res: any) {
                that.cashInData['cash_in_no'] = res['auto_no'];
            });
    }
    onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }

    setPageData(): void {
        let that = this;
        if (that._params != undefined) {
            that.cashInData = Object.assign({}, that._params);
            that.mode = that._params['mode'];
            that.cashInData['btnTxt'] = that._params['btnTxt'];
            that.cashInData['amount'] = that._params['tot_amount'];
            if (that.mode != 'Add') {
                that.cashInData['date'] = new Date(that._params['cash_in_date']);
                that.cashInData['company_id'] = parseInt(that._params['company_id']);
            }
        }
    }

    onBackToList(): void {
        this.subscribeService.subReloadCashInGrid();
        this.subscribeService.subScribeDeleteActiveTab();
    }

    onSaveCashIn() {
        let that = this;
        let cashInDet = that.cashInData;
        let cashInDate = moment(cashInDet['date']).format('YYYY-MM-DD');
        if (cashInDet['btnTxt'] == 'Save') {
            let params = {
                cash_in_no: cashInDet['cash_in_no'],
                cash_out_no: cashInDet['cash_out_no'],
                cash_out_id: cashInDet['cash_out_id'],
                cash_out_date: cashInDet['cash_out_date'],
                cash_in_date: cashInDate,
                out_type: cashInDet['out_type'],
                companyid: cashInDet['from_company_id'],
                hv_userid: cashInDet['out_type'] === 'HV Team' ? cashInDet['requested_by'] : 0,
                to_company_id: cashInDet['to_branch_id'],
                to_hv_userid: cashInDet['out_type'] === 'HV Team' ? cashInDet['to_hvuserid'] : 0,
                amount: cashInDet['amount'],
                comments: cashInDet['comments'] ? cashInDet['comments'] : '',
                mode: 'Add'
            };
            this.isLoading = true;
            this.cashInService.addCashIn(params)
                .then(function (res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        swal(
                            'SUCCESS',
                            res.message,
                            'success'
                        );

                        that.cashInList = [];
                        that.cashInData = [];
                        that.subscribeService.subReloadCashInGrid();
                        that.subscribeService.subScribeDeleteActiveTab();
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });
        } else {
            let that = this;
            let params = {
                cash_in_no: cashInDet['cash_in_no'],
                cash_out_no: cashInDet['cash_out_no'],
                cash_out_id: cashInDet['cash_out_id'],
                cash_out_date: cashInDet['cash_out_date'],
                cash_in_date: cashInDate,
                out_type: cashInDet['out_type'],
                companyid: cashInDet['from_company_id'],
                hv_userid: cashInDet['out_type'] === 'HV Team' ? cashInDet['requested_by'] : 0,
                to_company_id: cashInDet['to_branch_id'],
                to_hv_userid: cashInDet['out_type'] === 'HV Team' ? cashInDet['to_hvuserid'] : 0,
                amount: cashInDet['amount'],
                comments: cashInDet['comments'] ? cashInDet['comments'] : '',
                cash_in_id: cashInDet['cash_in_id'],
                mode: 'Update'
            };
            this.isLoading = true;
            this.cashInService.UpdateCashIn(params)
                .then(function (res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        swal(
                            'SUCCESS',
                            res.message,
                            'success'
                        );
                        that.subscribeService.subReloadCashInGrid();
                        that.subscribeService.subScribeDeleteActiveTab();
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });
        }

    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/cashIn/addCashIn.component.ts